import {
  B_01,
  BANNER_DEFAULTS,
  hideB01Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B01_PLASMIC_PROPS = {
  heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_01].heading,
    description: "Main heading (B01 only)",
    hidden: hideB01Props,
  },
  primaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_01].primaryButtonText,
    description: "Primary CTA button text (B01 only)",
    hidden: hideB01Props,
  },
  primaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_01].primaryButtonUrl,
    description: "Primary CTA button URL (B01 only)",
    hidden: hideB01Props,
  },
  mobileImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_01].mobileImg,
    description: "Mobile/tablet image (B01 only)",
    hidden: hideB01Props,
  },
  desktopImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_01].desktopImg,
    description: "Desktop image (B01 only)",
    hidden: hideB01Props,
  },
  imageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_01].imageAlt,
    description: "Image alt text for desktop and mobile (B01 only)",
    hidden: hideB01Props,
  },
  listItems: {
    type: "array",
    defaultValue: BANNER_DEFAULTS[B_01].listItems,
    description: "List items with text, icon, and icon alt (B01 only)",
    hidden: hideB01Props,
    itemType: {
      type: "object",
      fields: {
        text: {
          type: "string",
          description: "List item text",
        },
        icon: {
          type: "imageUrl",
          description: "List item icon",
        },
        iconAlt: {
          type: "string",
          description: "List item icon alt text",
        },
      },
    },
  },
};
